import { motion } from 'framer-motion';
import { useState } from 'react';
import type { ProposalPayment } from '@/api/commercial/proposals';
import type { PaymentFormState } from '@/hooks/commercial/use-cart-step-validation';
import type { IProposalCartItem } from '@/types/commercial/cart';
import { StepCartAddItemsDialog } from './step-cart-add-items-dialog';
import { StepCartContainer } from './step-cart-container';

interface StepCartProps {
  proposalId?: string;
  clientId?: string;
  savedPayment?: ProposalPayment | null;
  isPickup?: boolean;
  onPaymentStateChange?: (payment: PaymentFormState | undefined) => void;
  onSavePaymentRef?: (saveFn: (() => Promise<void>) | null) => void;
}

export function StepCart({
  proposalId,
  clientId,
  savedPayment,
  isPickup,
  onPaymentStateChange,
  onSavePaymentRef,
}: StepCartProps) {
  const [addItemsDialogOpen, setAddItemsDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<IProposalCartItem | null>(null);

  const handleCloseDialog = () => {
    setAddItemsDialogOpen(false);
    setEditingItem(null);
  };

  return (
    <>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <StepCartContainer
          proposalId={proposalId}
          savedPayment={savedPayment}
          isPickup={isPickup}
          onOpenAddItems={() => setAddItemsDialogOpen(true)}
          onEditItem={(item) => {
            setEditingItem(item);
            setAddItemsDialogOpen(true);
          }}
          onPaymentStateChange={onPaymentStateChange}
          onSavePaymentRef={onSavePaymentRef}
        />
      </motion.div>

      <StepCartAddItemsDialog
        open={addItemsDialogOpen}
        onClose={handleCloseDialog}
        proposalId={proposalId}
        accountId={clientId}
        editingItem={editingItem}
      />
    </>
  );
}
